import { useQuery } from '@tanstack/react-query';

import { api } from '../../../core/network/api';
import { documentationKeys } from '../queries/keys';
import { documentationPaths } from '../queries/paths';

// TSS vite/03 — server state for a project's documentation.

// The documents of one kind for one project. Active ones only: a document given
// a soft delete (`status` 1) keeps its row, and showing it as the project's
// reference would present something somebody retired.
//
// Up to 100, the cap: a project with more than a hundred API references has a
// problem this screen is not the place to solve.
export function useProjectDocuments(projectId, kind) {
    const params = { project_id: projectId, kind, limit: 100, offset: 0 };

    return useQuery({
        queryKey: documentationKeys.list(params),
        queryFn: ({ signal }) => api
            .get(documentationPaths.documents(), { params, signal })
            .then(r => (r.data?.items ?? []).filter(item => item.status === 2)),
        enabled: !!projectId,
    });
}

// The text of a document is its NEWEST version: a document points at its latest
// version, which is what the context package sends to the agents too. Asked for
// with `limit: 1` — the versions come newest first. `null` when it has none yet.
export function useLatestVersion(documentId) {
    return useQuery({
        queryKey: documentationKeys.latest(documentId),
        queryFn: ({ signal }) => api
            .get(documentationPaths.versions(documentId), { params: { limit: 1, offset: 0 }, signal })
            .then(r => r.data?.items?.[0] ?? null),
        enabled: !!documentId,
    });
}
